import { render, staticRenderFns } from "./line-management-banner.vue?vue&type=template&id=2f31c229&scoped=true"
import script from "./line-management-banner.vue?vue&type=script&lang=js"
export * from "./line-management-banner.vue?vue&type=script&lang=js"
import style0 from "./line-management-banner.vue?vue&type=style&index=0&id=2f31c229&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f31c229",
  null
  
)

export default component.exports